/**
 * The outlet endpoints name their outlets in upper case ("BRIGHT NEJO") while
 * the screens show them as written ("Bright Nejo").
 *
 * Only a word that is entirely upper case is title-cased, so a mixed-case name
 * keeps its form: "V.I" stays "V.I", "restaurant" stays lower case, and
 * "Bright Nejo test" and "Bright Nejo Test" remain distinct rather than
 * collapsing to the same string.
 */
export const toOutletDisplayName = (name?: string): string | undefined =>
  name
    ?.split(" ")
    .map((word) =>
      /^[A-Z]{2,}$/.test(word)
        ? word.charAt(0) + word.slice(1).toLowerCase()
        : word
    )
    .join(" ");
